(function () {
    'use strict';

    angular.module('app').factory('UserService', UserService);

    UserService.$inject = ['$rootScope', 'API', 'NotifyService', '$location', 'localStorageService', 'RECaptchaService'];

    function UserService($rootScope, API, NotifyService, $location, localStorageService, RECaptchaService) {
        $rootScope.USER = {};
        var service = {};

        API.setApiToken(localStorageService.get('_t'));
        if (isAuthorized()) {
            try {
                $rootScope.USER = JSON.parse(localStorageService.get('user'));
                if (Sentry) {
                    Sentry.onLoad(function () {
                        console.info('Sentry.setUser', $rootScope.USER);
                        Sentry.setUser({
                            id: $rootScope.USER.id,
                            username: $rootScope.USER.login
                        });
                    });
                }
            } catch (e) {
                Logout();
            }
        }

        /**
         * User login
         */
        service.Login = function (data, callback) {
            API.post('/user/token', data, function (success, response) {
                if (success) {
                    _storeToken(response.token);
                    _storeUser(response.user);
                    $rootScope.$broadcast('user-login');
                }
                callback(success, response);
            });
        };

        service.Loginv2 = function (data, callback) {
            API.post('/user/token/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/token', data, function (success, response) {
                                    if (success) {
                                        if (response.user && response.token) {
                                            _storeToken(response.token);
                                            // _storeUser(response.user);
                                            // $rootScope.$broadcast('user-login');
                                        }

                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/token', data, function (success, response) {
                                if (success) {
                                    _storeToken(response.token);
                                    // _storeUser(response.user);
                                    // $rootScope.$broadcast('user-login');
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };

        /**
         * User logout
         */
        service.Logout = function (admin, login) {
            Logout(admin, login);
        };

        /**
         * User register
         */
        service.Register = function (data, callback) {
            API.post('/user/register', data, function (success, response) {
                if (success) {
                    _storeToken(response.token);
                    _storeUser(response.user);
                    $rootScope.$broadcast('user-register');
                }
                callback(success, response);
            });
        };

        service.Registerv2 = function (data, callback) {
            API.post('/user/register/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/register', data, function (success, response) {
                                    if (success) {
                                        NotifyService.Success(response.message, false);
                                        if (response.user && response.token) {
                                            _storeToken(response.token);
                                        }

                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/register', data, function (success, response) {
                                if (success) {
                                    _storeToken(response.token);
                                    _storeUser(response.user);
                                    $rootScope.$broadcast('user-register');
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };

        /**
         * User login
         */
        service.ChangePassword = function (data, callback) {
            API.post('/user/change_password', data, function (success, response) {
                if (success) {
                    _storeToken(response.token);
                }

                callback(success, response);
            });
        };

        // service.CheckMail = function(data, callback) {
        //   API.post('/user/validate_email', data, function(success, response) {
        //     if (success) {
        //     }
        //     callback(success, response);
        //   });
        // };

        service.validateEmail = function (data, callback) {
            API.post('/user/email/validate', data, function (success, response) {
                if (success) {
                }
                callback(success, response);
            });
        };

        service.validatePhone = function (data, callback) {
            API.post('/user/phone/validate', data, function (success, response) {
                if (success) {
                }
                callback(success, response);
            });
        };

        /*new registration*/
        /*
        * validate email
        */
        service.emailVerify = function (data, callback) {
            API.post('/user/email/verify/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/email/verify', data, function (success, response) {
                                    if (success) {
                                        NotifyService.Success(response.message, false);
                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/email/verify', data, function (success, response) {
                                if (success) {
                                    NotifyService.Success(response.message, false);
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };

        /**
         * validate  phone
         */
        service.phoneVerify = function (data, callback) {
            API.post('/user/phone/verify/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/phone/verify', data, function (success, response) {
                                    if (success) {
                                        NotifyService.Success(response.message, false);
                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/phone/verify', data, function (success, response) {
                                if (success) {
                                    NotifyService.Success(response.message, false);
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };
        /*end of new registration*/

        /**
         * Request pin for new user registration with phone
         */
        service.RequestPin = function (data, callback) {
            API.post('/user/register', data, function (success, response) {
                if (success) {
                    NotifyService.Success(response.message, false);
                }
                callback(success, response);
            });
        };

        service.RequestPinv2 = function (data, callback) {
            API.post('/user/register/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/register', data, function (success, response) {
                                    if (success) {
                                        NotifyService.Success(response.message, false);
                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/register', data, function (success, response) {
                                if (success) {
                                    NotifyService.Success(response.message, false);
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };

        /**
         * Request pin for login
         */
        service.RequestLoginPin = function (data, callback) {
            API.post('/user/token', data, function (success, response) {
                if (success) {
                    NotifyService.Success(response.message, false);
                }
                callback(success, response);
            });
        };

        service.RequestLoginPinv2 = function (data, callback) {
            API.post('/user/token/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/token', data, function (success, response) {
                                    if (success) {
                                        NotifyService.Success(response.message, false);
                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/token', data, function (success, response) {
                                if (success) {
                                    NotifyService.Success(response.message, false);
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };

        /**
         * Get user profile
         */
        service.Profile = function (callback) {
            API.get('/user/profile', function (success, response) {
                if (success) {
                    _storeUser(response);
                }
                callback(success, response);
            });
        };

        /**
         * Change user profile
         */
        service.ChangeProfile = function (data, callback) {
            API.patch('/user/profile', data, function (success, response) {
                if (success) {
                    _storeUser(response);
                }
                callback(success, response);
            });
        };

        /**
         * Change user profile
         */
        service.ChangeLanguage = function (data, callback) {
            API.patch('/user/language', data, function (success, response) {
                if (success) {
                }
                callback(success, response);
            });
        };

        service.RequestConfirmEmail = function (email, callback) {
            API.get('/user/request_confirm_email/' + encodeURIComponent(email), callback);
        };

        service.ConfirmEmail = function (token, callback) {
            API.get('/user/confirm_email/' + token, callback);
        };

        /**
         * Change user profile email
         */

        service.RequestEmailChangePre = function (data, callback) {
            API.post('/user/email/change/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/email/change', data, function (success, response) {
                                    if (success) {
                                        NotifyService.Success(response.message, false);
                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/email/change', data, function (success, response) {
                                if (success) {
                                    NotifyService.Success(response.message, false);
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };

        /**
         * Change user profile phone
         */

        service.RequestPhoneChangePre = function (data, callback) {
            API.post('/user/phone/change/pre', data, function (success, response) {
                if (success) {
                    switch (response.protection_options.protection) {
                        case 'recaptcha': {
                            RECaptchaService.getToken(response.protection_options.params.sitekey, response.protection_options.params.action).then(function (recaptchaToken) {
                                data.recaptcha_token = recaptchaToken;
                                API.post('/user/phone/change', data, function (success, response) {
                                    if (success) {
                                        NotifyService.Success(response.message, false);
                                    }
                                    callback(success, response);
                                });
                            });
                        }
                            break;
                        default: {
                            API.post('/user/phone/change', data, function (success, response) {
                                if (success) {
                                    NotifyService.Success(response.message, false);
                                }
                                callback(success, response);
                            });
                        }
                    }
                }
            });
        };

        /**
         * Upload avatar
         */
        service.uploadAvatar = function (data, callback) {
            API.postImage('/user/avatar', data, function (success, response) {
                if (success) {
                    // КОСТЫЛЬ !!! by roma
                    // if (!!response.avatar && response.avatar.length) {
                    //     response.avatar += '?' + Math.random().toString(36);
                    // }
                    _storeUser(response);
                }
                callback(success, response);
            });
        };

        /**
         * Send info to inCust support
         */
        service.SendToSupport = function (data, subject, callback) {
            var post_data = angular.copy(data);
            delete post_data['password'];
            post_data['subject'] = '[inCust], {0}, {1} '.format($rootScope.LANG, subject);
            post_data['send_from'] = $location.path();
            API.post('/user/incust_support', post_data, callback);
        };

        service.NotificationsSettings = function (callback) {
            API.get('/user/notifications_settings', callback);
        };

        service.NotificationsSettingsEdit = function (post_data, callback) {
            API.patch('/user/notifications_settings', post_data, callback);
        };

        service.QRCode = function (salt, date) {
            API.get('/user/qrcode?' + paramsToUrlQueryEncodeURIComponent({salt: salt, date: date}), callback);
        };

        service._storeUserPublic = function (user) {
            _storeUser(user);
        };

        /**
         * Renew and return new token and user profile.
         */
        service.reNewToken = function (callback) {
            API.get('/user/token/renew', function (success, response) {
                if (success) {
                    _storeToken(response.token);
                    _storeUser(response.user);
                    $rootScope.$broadcast('user-login');
                }
                callback(success, response);
            });
        };

        return service;

        function Logout(admin, login) {
            console.info('LOGOUT');
            API.setApiToken('');
            $rootScope.USER = null;
            $rootScope.MENU_ITEMS = null;
            $rootScope.$broadcast('user-logout');
            var _suffix = ($rootScope.ENV && $rootScope.ENV.tools) ? $rootScope.ENV.tools.storage_suffix : '';

            if (Sentry) {
                Sentry.onLoad(function () {
                    Sentry.setUser(null);
                });
            }
            localStorageService.remove('_t', 'user', 'u', 'env', 'pqm' + _suffix, 'm_cols' + _suffix, 'pqt' + _suffix, 't_cols' + _suffix, 'pqc' + _suffix, 'c_cols' + _suffix);

            $rootScope.flashMessages = [];
            $rootScope.ENV = {};
            try {
                if (localStorage && localStorage.apiBase) {
                    delete localStorage.apiBase;
                }
            } catch (e) {
            }
            if (!admin && !login) {
                if (appConfig.platformParams.helpcrunch) {
                    window.HelpCrunch('closeChat');
                    window.HelpCrunch('hideChatWidget');
                }
                $location.path('/singin');
            }
        }

        /**
         * Return true if user is authorized
         */
        function isAuthorized() {
            var apiToken = API.getApiToken();
            $rootScope.USER.Authorized = (apiToken && apiToken.length > 0);
            return $rootScope.USER.Authorized;
        }

        function _storeUser(user) {
            $rootScope.USER = user;
            $rootScope.USER.Authorized = true;
            localStorageService.set('user', JSON.stringify(user));
        }

        function _storeToken(token) {
            API.setApiToken(token);
            localStorageService.set('_t', token);
        }

    }

})();

